// ** MUI Components
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

// ** Styled Components
const LoginWrapper = styled(Box)(({ theme }) => ({
  backgroundImage: `url("/images/scheduler_background_2.png")`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  minHeight: '100vh', // height -> minHeight (모바일 세로 스크롤 대응)
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(3), // 모바일에서 화면 끝에 붙지 않도록 여백 추가
}));

export default LoginWrapper;
